module.exports = __webpack_public_path__ + "img/145.1708a603.png";